module.exports = __webpack_public_path__ + "static/img/footer2.c9bba6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/footer2.png
// module id = vIt+
// module chunks = 1